import React, { ChangeEvent, useEffect } from 'react';
import { clsx } from 'clsx';
import { Input, InputProps } from 'antd';
import { formatPhone } from 'works/legacy/services/phone-service';

type Props = {
  className?: string;
  value?: string;
  onChange?: (value: ChangeEvent<HTMLInputElement> | string) => void;
} & InputProps;

export const PhoneInput = ({ className, value, onChange, ...props }: Props) => {
  useEffect(() => {
    const formattedValue = formatPhone(value || '');

    if (formattedValue && formattedValue !== value) {
      onChange?.(formattedValue);
    }
    // Yeah, only onMount stuff.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Input
      {...props}
      className={clsx('wk-phone-input', className)}
      data-testid="wk-phone-input"
      min={0}
      maxLength={12}
      value={value && formatPhone(value)}
      onChange={onChange}
      onInput={(e) => {
        // useful only when input is not controlled by a FormItem
        if (!value) {
          const input = e.target;
          // eslint-disable-next-line
          // @ts-ignore: yes ts, input.value exists.
          input.value = formatPhone(input.value);
        }
      }}
    />
  );
};
